import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import ApiClient from "../API/ApiClient";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import SpinningCubePopup from "../page/Home/SpinningCubePopup";

const Footer = () => {
  const { slug = "", language = "en" } = useParams();
  const { getRequestApi, postRequestApi } = ApiClient();

  const homePage = useSelector((state) => state.homePage);
  const buildDate = process.env.REACT_APP_BUILD_DATE;
  const post_meta = homePage?.post_meta || {};
  const lastUpdatedDate = post_meta?.last_updated_date;

  function getLatestDate(d1, d2) {
    const date1 = new Date(d1);
    const date2 = new Date(d2);

    return date1 > date2 ? formatDate(date1) : formatDate(date2);
  }
  function formatDate(date) {
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  }
  let bannerStyle;

  if (post_meta?.footer_background) {
    bannerStyle = {
      backgroundColor: "#1d3f8a",

      backgroundImage: `url(${post_meta?.footer_background})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "left top",
      backgroundSize: "cover",
    };
  }
  const footer = useSelector((state) => state.footerMenu);
  const [inputValue, setInputValue] = useState("");
  const [message, setMessage] = useState(""); // For error/success message
  const [severity, setSeverity] = useState(""); // For error/success message
  const [isError, setIsError] = useState(false); // For determining message type
  const [isLoading, setIsLoading] = useState(false); // Loader State
  const [quickLinks, setQuickLinks] = useState([]);
  const [contactInfo, setContactInfo] = useState([]);
  const { executeRecaptcha } = useGoogleReCaptcha();

  const loadPreLoadData = async () => {
    const response = await getRequestApi(`menu/quick-link/${language}`);
    const response_contact = await getRequestApi(
      `post/type/address/${language}`
    );

    if (response?.data?.payload_data) {
      try {
        const parsedData = JSON.parse(response.data.payload_data);
        setQuickLinks(parsedData);
      } catch (error) {
        console.error("Failed to parse payload_data", error);
        setQuickLinks([]);
      }
    }
    if (response_contact?.data) {
      try {
        const parsedData = response_contact.data;
        // console.log("parsedData", parsedData);
        setContactInfo(parsedData);
      } catch (error) {
        console.error("Failed to parse payload_data", error);
        setContactInfo([]);
      }
    }
  };

  const [scriptContent, setScriptContent] = useState("");
  const innerpagedata = useSelector((state) => state.innerPage);
  useEffect(() => {
    const loadData = async () => {
      await loadPreLoadData();
      setIsLoading(false);
    };
    loadData();
  }, [slug, language]);

  useEffect(() => {
    if (innerpagedata?.title) {
      const breadcrumbList = [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: `https://nfdcindia.com/home/${language}`,
        },
      ];

      let position = 2;
      breadcrumbList.push({
        "@type": "ListItem",
        position,
        name: innerpagedata.title,
        item: window.location.href,
      });

      const schema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumbList,
      };

      const script = document.createElement("script");
      script.id = "breadcrumb-jsonld";
      script.type = "application/ld+json";
      script.innerHTML = JSON.stringify(schema);
      document.head.appendChild(script);
    }

    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.remove();
    }

    const canonicalLink = document.createElement("link");
    canonicalLink.setAttribute("rel", "canonical");
    canonicalLink.setAttribute("href", window.location.href);
    document.head.appendChild(canonicalLink);
  }, [innerpagedata?.title, innerpagedata?.post_meta?.breadcrum_1, language]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (!executeRecaptcha) {
      console.warn("Execute recaptcha not yet available");
      return;
    }

    const token = await executeRecaptcha("submit");

    try {
      const makeData = {
        email: inputValue,
      };
      const response = await postRequestApi(`subscribe`, {
        ...makeData,
        token,
      });
      if (response.status) {
        setOpen(true);
        setSeverity("success");
        setMessage(response.message); // Success message
        setInputValue("");
        setIsError(false);
      } else {
        setOpen(true);
        setSeverity("error");
        if (response?.message) {
          setMessage(response.message);
        } else if (response?.errors?.[0].message) {
          setMessage(response.errors[0].message);
        }

        setIsError(true);
      }
    } catch (error) {
      setOpen(true);
      setSeverity("error");
      setMessage("Failed to subscribe. Please check the form.");
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const [open, setOpen] = useState(false);
  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };
  return (
    <>
      <div>
        <Snackbar
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }} // ✅ Position at bottom-right
        >
          <Alert
            onClose={handleClose}
            severity={severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {message}
            {/* {console.log("msg", message)} */}
          </Alert>
        </Snackbar>
      </div>
      {/* <div id="text-resize-newdata"> */}
      <footer className=" text-black">
        {/* {post_meta?.is_cube_visible === '1' && (
                    <div className='cub'>
                        <SpinningCubePopup />
                    </div>
                )} */}

        <div className="footer-link ">
          <div className="footer-link-new">
            <div className="container">
              <div className="row">
                <div className="col-md-3">
                  {post_meta?.header_logo_1 ? (
                    <div className="footer-custom">
                      <img
                        src={
                          post_meta?.header_logo_1
                            ? post_meta.header_logo_1
                            : ""
                        }
                        alt="NFDC Cinemas of India logo"
                        role="img"
                        aria-label="NFDC Cinemas of India logo"
                      // aria-labelledby="NFDC Cinemas of India logo"
                      />
                    </div>
                  ) : (
                    <></>
                  )}

                  <p className="h4 mt-4">{post_meta?.subscribe_text || ""}</p>
                  <div class="input-group  mt-3 subscribe-form">
                    <input
                      type="text"
                      className="form-control"
                      placeholder={post_meta?.subscribe_email}
                      aria-label="Recipient's username"
                      aria-describedby="subscribe"
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                    />
                    <span
                      className="input-group-text"
                      id="subscribe"
                      onClick={handleSubmit}
                      style={{ cursor: isLoading ? "not-allowed" : "pointer" }}
                    >
                      {isLoading ? (
                        <CircularProgress size={20} />
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          className="bi bi-send"
                          viewBox="0 0 16 16"
                        >
                          <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576zm6.787-8.201L1.591 6.602l4.339 2.76z" />
                        </svg>
                      )}
                    </span>
                  </div>

                  <div class=" pt-4">
                    {post_meta?.indian_web_logo ? (
                      <a
                        href={
                          post_meta?.indian_web_link
                            ? post_meta.indian_web_link
                            : ""
                        }
                        target="_blank"
                      >
                        {" "}
                        <div className="footer-custom custom-logo">
                          <img
                            src={
                              post_meta?.indian_web_logo
                                ? post_meta.indian_web_logo
                                : ""
                            }
                            alt="indian.gov.in"
                          />
                        </div>
                      </a>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div class="last-update mt-3">
                    {post_meta?.last_updated_text}{" "}
                    <strong class="badge">
                      {getLatestDate(buildDate, lastUpdatedDate)}
                    </strong>
                  </div>
                </div>
                <div class="col-md-3">
                  <p className="h4">{post_meta?.our_company_text}</p>
                  <ul className="bottom-link">
                    {footer
                      ? footer.map((data) => (
                        <li key={data.url || "index"}>
                          {data.type === 1 ? (
                            <a
                              href={`/${data.url}/${language}`}
                              title={data.text}
                            >
                              {data.text}
                            </a>
                          ) : (
                            <a
                              href={data.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              title={data.text}
                              aria-label={data.text}
                            >
                              {data.text}
                            </a>
                          )}
                        </li>
                      ))
                      : null}
                  </ul>
                </div>
                <div class="col-md-3">
                  <p className="h4">{post_meta?.quick_links_text} </p>
                  <ul class="bottom-link">
                    {quickLinks
                      ? quickLinks.map((data) => (
                        <li key={data.url || "index"}>
                          {data.type === 1 ? (
                            <a
                              href={`/${data.url}/${language}`}
                              title={data.text}
                            >
                              {data.text}
                            </a>
                          ) : (
                            <a
                              href={data.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              title={data.text}
                              aria-label={data.text}
                            >
                              {data.text}
                            </a>
                          )}
                        </li>
                      ))
                      : null}
                    {/* <li ><a target="_blank" href={post_meta?.national_portal_url} name={post_meta?.national_portal_text} aria-label='National Portal of India Link'>{post_meta?.national_portal_text}</a></li> */}
                  </ul>
                </div>
                <div class="col-md-3">
                  <div className="contact-info">
                    <p className="h4">{post_meta?.head_office_text}</p>
                    {contactInfo.map((item, idx) => {
                      const type = item?.post_meta?.type;
                      if (type === "head_office") {
                        return (
                          <>
                            <p>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-geo-alt"
                                viewBox="0 0 16 16"
                              >
                                <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10"></path>
                                <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6"></path>
                              </svg>
                              {item?.post_meta?.address_line}
                            </p>
                            <p class="phone-num">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-telephone"
                                viewBox="0 0 16 16"
                              >
                                <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"></path>
                              </svg>
                              {item?.post_meta?.phone_number}
                            </p>
                          </>
                        );
                      }
                      return null;
                    })}

                    {contactInfo.map((item, idx) => {
                      const type = item?.post_meta?.type;
                      const meta = item?.post_meta || {};

                      if (type === "regional_offices") {
                        let headingText = "";

                        return (
                          <div key={idx}>
                            <p className="h4">{item?.title}</p>
                            <p>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-geo-alt"
                                viewBox="0 0 16 16"
                              >
                                <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10"></path>
                                <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6"></path>
                              </svg>

                              {meta?.address_line}
                            </p>
                            <p className="phone-num">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-telephone"
                                viewBox="0 0 16 16"
                              >
                                <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"></path>
                              </svg>
                              {meta?.phone_number}
                            </p>
                          </div>
                        );
                      }

                      return null;
                    })}
                  </div>
                </div>
                <div class="social-content pt-4">
                  <a
                    href={
                      post_meta?.facebook_link ? post_meta.facebook_link : ""
                    }
                    target="_blank"
                    title=" Facebook"
                    aria-label="Visit our Facebook page"
                  >
                    <i class="fb-icon"> Facebook</i>
                  </a>
                  <a
                    href={
                      post_meta?.twitter_link ? post_meta.twitter_link : ""
                    }
                    target="_blank"
                    aria-label="Visit our Twitter page"
                    title=" Twitter"
                  >
                    <i class="twitter-icon"></i> Twitter
                  </a>
                  <a
                    href={
                      post_meta?.linkedin_link ? post_meta.linkedin_link : ""
                    }
                    target="_blank"
                    aria-label="Visit our Linkedin page"
                    title=" LinkedIn"
                  >
                    <i class="linkedin-icon"> LinkedIn</i>
                  </a>
                  <a
                    href={
                      post_meta?.youtube_link ? post_meta.youtube_link : ""
                    }
                    target="_blank"
                    aria-label="Visit our Youtube page"
                  >
                    <i class="youtube-icon"> YouTube</i>
                  </a>
                  <a
                    href={post_meta?.insta_link ? post_meta.insta_link : ""}
                    target="_blank"
                    aria-label="Visit our Instagram page"
                  >
                    <i class="insta-icon"> Instagram</i>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center copyright">
            <div class="container">
              {" "}
              {post_meta?.copyright ? post_meta.copyright : <></>}
            </div>
            <div className="container captcha">
              <div
                dangerouslySetInnerHTML={{
                  __html: post_meta?.footer_google_captcha_text,
                }}
              />
            </div>
          </div>
        </div>
      </footer>
      {/* </div > */}
    </>
  );
};

export default Footer;
